import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfig, CMPS_APP_CONFIG } from '../../../../app.config';
import { catchErrorLogRet } from '../../../../common/rest.operators';
import { LtConfig } from '../../model/layout/lt-config.model';
import { LtUserConfig } from '../../model/layout/lt-user-config.model';
import { LtConfigView } from '../../model/layout/view/lt-config-view.model';

@Injectable({ providedIn: 'root' })
export class LayoutService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    upsertConfig(config: LtConfig): Observable<void> {
        return this._http
            .post<LtConfig | null>(
                `${this._appConfig.API_ENDPOINTS.INSIGHT}/layout/config`,
                config,
            )
            .pipe(catchErrorLogRet(null));
    }

    retrieveConfig(): Observable<LtConfigView | null> {
        return this._http
            .get<LtConfig | null>(
                `${this._appConfig.API_ENDPOINTS.INSIGHT}/layout/config`,
            )
            .pipe(catchErrorLogRet(null));
    }

    retrieveUserConfig(userId: number): Observable<LtUserConfig | null> {
        const params = new HttpParams().set('userId', String(userId));
        return this._http
            .get<LtUserConfig | null>(
                `${this._appConfig.API_ENDPOINTS.INSIGHT}/layout/user-config`,
                { params },
            )
            .pipe(catchErrorLogRet(null));
    }
}
